import { useState } from 'react';
import * as API from '../API';
import type MenuItem from '../Models/MenuItem';

const useFavoritesState = (defaultValue: MenuItem[]): [MenuItem[], Function] => {
    const [storedValue, setStoredValue] = useState<MenuItem[]>(defaultValue);

    const setValue = (newValue: MenuItem[], initial: boolean): void => {
        setStoredValue(newValue);
        if (!initial) {
            void API.user.updateFavorites(newValue);
        }
    };

    return [storedValue, setValue];
};

export default useFavoritesState;
